export default "__VITE_ASSET__6ef527c1__"